// Spinner.tsx — Token-aware loading indicator (keyframes live in tokens.css).
import React from 'react';

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
    size?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 12, style, ...rest }) => {
    const baseStyle: React.CSSProperties = {
        display: 'inline-block',
        width: `${size}px`,
        height: `${size}px`,
        border: '2px solid var(--color-surface-overlay-strong)',
        borderTopColor: 'var(--color-brand)',
        borderRadius: 'var(--radius-full)',
        animation: 'spin 0.6s linear infinite',
        boxSizing: 'border-box',
        ...style,
    };

    return <span role="status" aria-label="Loading" style={baseStyle} {...rest} />;
};

export default Spinner;
